import { Component, Inject, NgZone } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { CoreHelperService } from './providers/core-helper/core-helper.service';
import { NavigationEnd, Router } from '@angular/router';
import { UserManagementService } from './modules/auth/administration/user-management/user-management.service';
import { DOCUMENT } from '@angular/common';
import { UserDomainType, UserStatus } from './common/enum/user-domain';
import { NotificationHubService } from './providers/notification.service';
import { lastValueFrom } from 'rxjs';
import { DepartmentId } from './common/enum/department';
import { AuthSessionService } from './providers/auth-session/auth-session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {
  idleState = 'Not started.';
  timedOut: boolean = false;
  logoutTimer: string = "";
  interruptTimer: boolean = false;
  logoutInterval: any;
  onBreak: boolean = false;


  constructor(
    private idle: Idle,
    private _authSession: AuthSessionService,
    public _coreHelper: CoreHelperService,
    private _userManagementService: UserManagementService,
    private router: Router,
    private ngZone: NgZone,
    private _notificationService: NotificationHubService,
    @Inject(DOCUMENT) private document: any,
  ) {

    try {
      //Check Permission
      let urlToValidate = location.pathname.substr(1, location.pathname.length);
      if (urlToValidate.includes("non-auth/user-agreement")) {
        this.router.navigate(['non-auth/user-agreement']);
        return;
      }

      // Nothing to check before sign-in (login page, SSO return, or a session the AuthGuard
      // is about to restore from the cookie); the guard and login page handle those cases.
      const hasCachedUser = !this._coreHelper.isNullOrUndefined(this._coreHelper.getLoggedInUserDetail());
      if (hasCachedUser && urlToValidate !== "" && !urlToValidate.includes("login/callback") && !urlToValidate.includes("non-auth/user-agreement")) {
        let accessAllowed = this._coreHelper.checkModulePermission(urlToValidate);
        if (!accessAllowed) {
          let domainId = this._coreHelper.getUserDomain();
          let departmentId = this._coreHelper.getOpsDepartmentId();
          if (domainId == UserDomainType.Internal && departmentId != DepartmentId.Vob && departmentId != DepartmentId.Authorization) {
            this.router.navigate(['/auth/dashboard']);

          } else if (departmentId == DepartmentId.Vob) {
            this.router.navigate(['/auth/vob-dashboard']);
            this.modulePermissionDenied('Verification of Benefits');

          } else if (departmentId == DepartmentId.Authorization) {
            this.router.navigate(['/auth/auth-dashboard']);
            this.modulePermissionDenied('Authorization');

          } else {
            this.router.navigate(['/auth/facility-dashboard']);
            this.modulePermissionDenied('Facility Dashboard');
          }
        }
      }
      this.ngZone.runOutsideAngular(() => { });
    }
    catch (e) {
      this.logout();
    }
  }

  modulePermissionDenied(moduleName: string) {
    localStorage.setItem('adid', moduleName);
    this.router.navigate(['/auth/unauthorized']);
  }

  async ngOnInit() {
    // Initialize SignalR Notification Hub
    this._notificationService.startConnection();
    this._notificationService.hubMessageListener();

    // The hub authenticates with the session cookie, so reconnect once a session exists.
    this._authSession.signedIn$.subscribe(() => this._notificationService.ensureConnected());
  }

  ngAfterViewInit() {
  }

  ngAfterViewChecked() {
    try {
      this._coreHelper.selectedUserStatus = this._coreHelper.getUserStatusId();
      if (this._coreHelper.selectedUserStatus != null && this._coreHelper.selectedUserStatus.toString() == UserStatus.Break.toString() && !this.onBreak) {
        this.onBreak = true;
      }
    } catch (e) {
      this.logout();
    }
  }

  public async logout() {
    let requestModel = {
      userId: this._coreHelper.getUserId(),
      isLogin: 0,
      spMode: 1,
      userStatusId: UserStatus.Offline
    }
    if (requestModel.userId != undefined || requestModel.userId != null) {
      await lastValueFrom(this._userManagementService.addUpdateSignedUser(requestModel)).catch(() => null);
    };
    await this._authSession.logout();
  }

  continueWorkingAfterBreak() {
    this.updateUserStatusToAvailable();
    this.onBreak = false;
  }

  async updateUserStatusToAvailable() {
    let requestModel = {
      userId: this._coreHelper.getUserId(),
      isLogin: UserStatus.Available,
      spMode: 1,
      userStatusId: UserStatus.Available
    }
    if (requestModel.userId != undefined || requestModel.userId != null) {
      await lastValueFrom(this._userManagementService.addUpdateSignedUser(requestModel)).then((response) => {
        this._coreHelper.setUserStatusId(response.apiData);
        this.onBreak = false;
      });
    };
  }
}
